import React from 'react';
import { Grid } from '@material-ui/core';
import {
  createStyles,
  makeStyles,
  Theme,
} from '@material-ui/core/styles';
import clsx from 'clsx';
import { useSelector } from 'react-redux';

import { useTitle } from '../../../hooks';
import { Link, Button } from '../../../components';
import { selectRouter } from '../../../store/modules/app/selectors';
import { home } from '../../../routes/dashboard/user';

import { ExclamationCircleIcon } from '../../../components/icon/solid';

const useStyles = makeStyles(({ palette, colors, breakpoints }: Theme) => createStyles({
  root: {
    width: '100%',
    paddingTop: '25px',
    background: colors.backgroundColor,
    [breakpoints.down('xs')]: {
      background: '#FFF',
    },
    height: '100%',
  },
  wrapper: {
    background: '#FFF',
    maxWidth: '620px',
    // maxHeight: '480px',
    textAlign: 'center',
    paddingBottom: '96px',
    margin: '0 auto',
    paddingTop: '56px',
  },
  button: {
    margin: '50px 0 0 0',
    maxWidth: '190px',
    width: '100%',
    whiteSpace: 'nowrap',
    textTransform: 'none',
    fontSize: '16px',
    fontFamily: 'Montserrat, sans',
    boxShadow: 'none',
    letterSpacing: '0.21px',
  },
  buttonSingle: {
    color: '#FFF',
    background: palette.buttonSingle.color,
    '&:hover': {
      backgroundColor: palette.buttonSingle.color,
    },
  },
  buttonLink: {
    '&:hover': {
      textDecoration: 'none',
    },
  },
  text: {
    fontFamily: 'Montserrat',
    fontSize: '16px',
    color: '#26325F',
    fontWeight: 500,
  },
  title: {
    fontSize: '24px',
  },
  content: {
    maxWidth: '410px',
    margin: 'auto',
  },
  icon: {
    color: '#F8221A',
    fontSize: '64px',

  },
  previousUrl: {
    overflowWrap: 'break-word',
  },
}), { name: 'Dashboard' });

const PageNotFoundError = () => {
  useTitle('Dashboard');
  const classes = useStyles();

  const { previousPath } = useSelector(selectRouter);

  const url = `${window.location.origin}${previousPath}`;

  return (
    <Grid className={classes.root}>
      <Grid item xs={12} className={classes.wrapper}>
        <ExclamationCircleIcon className={classes.icon} />
        <div className={classes.content}>
          <h2 className={clsx(classes.text, classes.title)}>Whoops, it looks like the requested URL is invalid.</h2>
          <p className={classes.text}>
            We tried to find this path, but something about it is invalid:
          </p>
          <p>
            <a className={classes.previousUrl} href={url}>{ url }</a>
          </p>
          <Link to={home.path as string} className={classes.buttonLink}>
            <Button
              variant="contained"
              className={clsx(classes.button, classes.buttonSingle)}
              data-intercom-target="ClipPress button"
            >
              Go to Dashboard
            </Button>
          </Link>
        </div>
      </Grid>
    </Grid>
  );
};

export default PageNotFoundError;
